<div class="title">Projekt jogosultságok:</div>
<p>Felhasználó: {{projectPermission.user.firstName}} {{projectPermission.user.lastName}}</p>
<p>Projekt: {{projectPermission.project.name}}</p>
<div class="permission-container">
  <mat-slide-toggle [(ngModel)]="projectPermission.manageUsers">Felhasználók kezelése</mat-slide-toggle>
  <mat-slide-toggle [checked]="true" disabled>Ticket létrehozása</mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="projectPermission.update">Projekt módosítás</mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="projectPermission.delete">Ticket törlése</mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="projectPermission.updateSchema">Séma módosítása</mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="projectPermission.updateLayers">Rétegmenedzsment</mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="projectPermission.updateArcgis">Arcgis hozzáférés</mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="projectPermission.updateTickets">Ticket módosítás</mat-slide-toggle>
</div>
<div class="save-button">
  <app-button [customColor]="'green'" [title]="'Mentés'" (click)="save()"></app-button>
</div>
